import UploadFile from '../../../../control/uploadFile/uploadFile'
import useUploadFilePlayground from './useUploadFilePlayground'
const UploadFilePlaygroundView = () => {
    return (
        <div>
            <h1>Upload File</h1>
            <div>{/* <UploadFile name="xxx" /> */}</div>
        </div>
    )
}

const UploadFilePlayground = () => {
    const uploadFilePlayground = useUploadFilePlayground()
    return <UploadFilePlaygroundView {...uploadFilePlayground} />
}

export default UploadFilePlayground
